import "./styles/base.css";
import { initMotion } from "./motion";

window.addEventListener("DOMContentLoaded", () => {
	initMotion();
});
